import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Customers from '../sales/Customers';
import Suppliers from '../purchases/Suppliers';
import UsersPage from '../../pages/people/UsersPage';
import SalesmenPage from '../../pages/people/SalesmenPage';

const People = () => {
  return (
    <Routes>
      <Route path="customers" element={<Customers />} />
      <Route path="suppliers" element={<Suppliers />} />
      <Route path="users" element={<UsersPage />} />
      <Route path="salesmen" element={<SalesmenPage />} />
    </Routes>
  );
};

export default People; 